import { inject, Injectable } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';

import type { DefineFormData, UnwrapSignal } from '@core/ask-hr-dynamic-forms-types';

@Injectable({ providedIn: 'root' })
export class QuestionWithOptionsService {
  private readonly formBuilder = inject(NonNullableFormBuilder);

  public createQuestionForm(
    data?: DefineFormData,
  ): UnwrapSignal<
    import('./question-with-options.component').QuestionWithOptionsComponent['defineForm']
  > {
    return this.formBuilder.group({
      question: this.formBuilder.control(<string>data?.value?.question ?? '', Validators.required),
      hint: this.formBuilder.control(<string>data?.value?.hint ?? ''),
      required: this.formBuilder.control(<boolean>data?.value?.required ?? true),
      options: this.formBuilder.array(
        (
          <Array<{ value: string }> | undefined>data?.value?.options ?? [
            { value: '' },
            { value: '' },
          ]
        ).map(option =>
          this.formBuilder.group({
            value: this.formBuilder.control(option.value, Validators.required),
          }),
        ),
      ),
    });
  }
}
